<div class="domain-selection-container">
  @if (domains.length > 0) {
    <select
      class="domain-select"
      [value]="selectedDomainId || ''"
      (change)="onDomainChange($event)"
      [disabled]="disabled"
      [attr.aria-label]="'Select domain'"
    >
      @for (domain of sortedDomains; track domain.uuid) {
        <option [value]="domain.uuid" [selected]="domain.uuid === selectedDomainId">{{ domain.name }}</option>
      }
    </select>
  }
</div>

